import { Component } from 'react';
import { chiudiAvvio } from '../avvio';

// Rete di sicurezza contro la schermata bianca.
//
// In React, se un singolo componente va in errore mentre disegna la pagina,
// l'app intera si spegne e all'utente resta uno schermo bianco senza
// spiegazioni. Questo componente intercetta l'errore e mostra invece un
// messaggio leggibile con un bottone per ricaricare.
//
// Non nasconde i problemi: l'errore resta scritto nella console del browser,
// e il testo esatto e' consultabile aprendo "Dettagli tecnici", cosi' puoi
// copiarlo e passarmelo.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Errore non gestito:', error, info);
    // Senza questo la schermata di avvio resterebbe sopra il messaggio.
    chiudiAvvio();
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', background: '#181614', color: '#E8DDD0',
        fontFamily: "'Exo 2', sans-serif",
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        padding: '24px 20px', textAlign: 'center', boxSizing: 'border-box',
      }}>
        <img src="/logo.png" alt="Jammo" style={{ height: 72, objectFit: 'contain', marginBottom: 28 }} />
        <div style={{ fontSize: 24, fontWeight: 800, marginBottom: 10 }}>
          Qualcosa non ha funzionato
        </div>
        <div style={{ fontSize: 18, color: 'rgba(255,255,255,0.6)', lineHeight: 1.6, maxWidth: 380, marginBottom: 28 }}>
          Prova a ricaricare la pagina. Se il problema si ripete, scrivi a Paolo
          indicando cosa stavi facendo.
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '15px 40px', borderRadius: 12, border: 'none',
            background: '#ED4D1D', color: '#fff', fontSize: 19, fontWeight: 800,
            cursor: 'pointer', fontFamily: "'Exo 2', sans-serif", minHeight: 44,
          }}>
          Ricarica
        </button>
        <button
          onClick={() => { window.location.hash = ''; window.location.reload(); }}
          style={{
            marginTop: 12, padding: '12px 28px', borderRadius: 12,
            background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)',
            color: 'rgba(255,255,255,0.7)', fontSize: 17, fontWeight: 600,
            cursor: 'pointer', fontFamily: "'Exo 2', sans-serif", minHeight: 44,
          }}>
          Torna alla home
        </button>

        <details style={{ marginTop: 32, maxWidth: 420, width: '100%' }}>
          <summary style={{ fontSize: 16, color: 'rgba(255,255,255,0.35)', cursor: 'pointer' }}>
            Dettagli tecnici
          </summary>
          <pre style={{
            marginTop: 10, padding: '12px 14px', borderRadius: 10,
            background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
            fontSize: 16, color: 'rgba(255,255,255,0.55)', lineHeight: 1.6,
            textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            maxHeight: 220, overflowY: 'auto', fontFamily: 'monospace',
          }}>
            {String(this.state.error?.stack || this.state.error)}
          </pre>
        </details>
      </div>
    );
  }
}

export default ErrorBoundary;
